<template>
  <div class="hq-display-block">
    <!-- Start Add New Portfolio -->
    <v-dialog v-model="showAddPortfolio" width="800">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-icon color="primary" @click="showAddPortfolio = false"
            >mdi-close</v-icon
          >
        </v-card-title>

        <v-card-text>
          <portfolio-create
            :show.sync="showAddPortfolio"
            :showCreate.sync="showAddPortfolio"
            :refreshTable.sync="refreshTable"
            :id="items?.id"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End Add New Portfolio -->

    <v-row class="hq-details-row">
      <v-col cols="4" class="hq-main-title-card">
        <div>
          <a href="#" class="goback">
            <v-icon color="#5E5873">mdi-arrow-left</v-icon>Back
          </a>

          <div class="breadcrumb-block">
            <a href="/admin/dashboard" class="breadcrumb-link-home">Home</a>
            <v-icon>mdi-chevron-right</v-icon>
            <a href="#" class="breadcrumb-link">VS Portfolios</a>
          </div>

          <h1 class="heading">Vacancy Schedules</h1>
          <div>
            <strong style="color: #5e5873"
              >{{ thismonthlong }} Update Progress</strong
            >
          </div>
        </div>
      </v-col>

      <v-col cols="16">
        <!-- KPI row -->
        <v-row class="hq-kpi-row" align="stretch">
          <!-- GLOBAL Active Portfolios (independent of search) -->
          <v-col cols="3" class="">
            <v-card class="new-note-card kpi-card" flat>
              <v-list-item class="">
                <v-list-item-title class="text-h5 text-center"
                  >Active Portfolios</v-list-item-title
                >
              </v-list-item>
              <v-card-text class="kpi-body">
                <div class="text-h2 text-center">
                  {{ activePortfoliosGlobalCount }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- GLOBAL Irregular Portfolio (independent of search) -->
          <v-col cols="3" class="d-flex">
            <v-card class="new-note-card kpi-card" flat>
              <v-list-item class="pa-0">
                <v-list-item-title class="text-h5 text-center mt-2 mb-0"
                  >Irregular Portfolio</v-list-item-title
                >
              </v-list-item>
              <v-card-text class="kpi-body">
                <div class="text-h2 text-center">
                  {{ irregularPortfoliosGlobalCount }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- THIS MONTH -->
          <v-col cols="3" class="d-flex">
            <v-card class="new-note-card kpi-card pa-0" flat>
              <v-list-item class="pa-0">
                <v-list-item-title class="text-h5 text-center mt-2 mb-0">
                  {{ thismonth }} Building Updates
                  <!-- Optional sub (counts) -->
                  <!-- <div class="card-sub mt-0">({{ formatNum(thisMonthDistinctBuildings) }} / {{ formatNum(totalBuildingsCount) }})</div> -->
                </v-list-item-title>
              </v-list-item>

              <v-card-text class="pa-0 kpi-chart">
                <apexchart
                  type="radialBar"
                  height="160"
                  :options="semiGaugeOptions"
                  :series="[buildingsCheckedPctThisMonth]"
                />
              </v-card-text>
            </v-card>
          </v-col>

          <!-- PREVIOUS MONTH (same layout) -->
          <v-col cols="3" class="d-flex">
            <v-card class="new-note-card kpi-card pa-0" flat>
              <v-list-item class="pa-0">
                <v-list-item-title class="text-h5 text-center mt-2 mb-0">
                  {{ prevMonthShort }} Building Updates
                  <!-- <div class="card-sub mt-0">({{ formatNum(prevMonthDistinctBuildings) }} / {{ formatNum(totalBuildingsCount) }})</div> -->
                </v-list-item-title>
              </v-list-item>

              <v-card-text class="pa-0 kpi-chart">
                <apexchart
                  type="radialBar"
                  height="160"
                  :options="semiGaugeOptionsPrev"
                  :series="[buildingsCheckedPctPrevMonth]"
                />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <base-loader-bar :is-loading="isLoading" />

    <!-- Tabs Row -->
    <v-row class="hqSectTab">
      <v-col cols="8">
        <v-tabs fixed-tabs v-model="tab">
          <v-tab
            class="hq-tabs"
            v-for="(tabName, i) in vstabs"
            :key="i"
            :class="'top-table-nav tab-' + i"
            >{{ tabName }}</v-tab
          >
        </v-tabs>
      </v-col>
      <v-col cols="4" class="d-flex justify-end m-0 p-0"></v-col>
    </v-row>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <base-custom-table
          :header="vsheaders"
          :items="portfolios?.records"
          :search="search"
          :selectHide="false"
          :tableType="'VS Portfolios'"
          :isDeletedState="true"
          :remove="[
            'mancoid',
            'irregular',
            'owner',
            'ownerid',
            'manco',
            'active',
            'createdAt',
            'createdBy',
            'assignedTo',
          ]"
          :isLoading="isLoading"
          :pageLimit="limitPortfolio"
          :pageLimit.sync="limitPortfolio"
          :show_limiter="true"
          :maxItems="maxPortfolio"
          xxsortRule.sync="sortContacts"
          :passedTemplates="[
            'contact',
            'name',
            'customActions',
            'checked_percent',
            'manco',
            'owner',
          ]"
          :passedExpanded="expanded"
          :expanded.sync="expanded"
        >
          <template v-slot:tableHeaderSpot>
            <portfolio-filter-quick :contactsFilters.sync="contactsFilters" />
          </template>

          <template v-slot:customSlotBtns>
            <v-btn
              class="ml-2"
              @click="showAddPortfolio = !showAddPortfolio"
              elevation="0"
              color="#F37168"
            >
              <v-icon>mdi-plus</v-icon> Add Portfolio
            </v-btn>
          </template>

          <template v-slot:name="{ item }">
            <a :href="'/admin/vsportfolio/' + item?.id">{{ item.name }}</a>
            <i
              v-if="item.irregular"
              class="fi fi-rr-hand ps-1"
              style="color: #f44819"
            ></i>
          </template>

          <template v-slot:manco="{ item }">
            <a :href="'/admin/contacts#' + item?.mancoid">{{
              item.manco?.name
            }}</a>
          </template>

          <template v-slot:owner="{ item }">
            <a :href="'/admin/contacts#' + item?.ownerid">{{
              item.owner?.name
            }}</a>
          </template>

          <template v-slot:checked_percent="{ item }">
            <v-progress-linear
              v-model="item.checked_percent"
              color="#367BF5"
              height="20"
            >
              <template v-slot:default="{ value }"
                ><strong>{{ item.checked_percent }}%</strong></template
              >
            </v-progress-linear>
          </template>

          <!-- Actions -->
          <template v-slot:customActions="{ item }">
            <i
              class="fi fi-rr-edit"
              :title="item?.id + ' Edit Portfolio'"
              @click="
                items = item;
                showAddPortfolio = true;
              "
            ></i>
            <i
              class="fi fi-rs-trash"
              title="Delete Portfolio"
              @click="deleteItem(item)"
            ></i>
          </template>

          <template v-slot:tablePagination>
            <v-pagination
              v-if="limitPortfolio != 0"
              class="text-center custom-pagination"
              v-model="pagePortfolio"
              :length="Math.ceil(maxPortfolio / limitPortfolio)"
              :total-visible="5"
              outlined
            />
          </template>
        </base-custom-table>
      </v-tab-item>

      <v-tab-item>
        <analytics />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import defaultProfile from "../../../assets/img/avatar.png";
import GoogleMap from "../../../components/Base/GoogleMaps/GoogleMaps.vue";
import PortfolioCreate from "../../../components/Base/VsAdmin/PortfolioCreate";
import PortfolioFilterQuick from "@/components/Base/Property/PortfolioFilterQuick";
import ExportVs from "@/components/Base/Property/ExportVs.vue";
import ExportProps from "@/components/Base/Property/ExportProps.vue";
import Analytics from "@/components/Base/VsAdmin/Analytics";
import { GET_PORTFOLIOS } from "@/queries/portfolio";
import { GET_HQNAMES_IDS } from "@/queries/hqname";
import moment from "moment";

export default {
  props: {
    id: { type: String, default: "" },
    editType: { type: String, default: "default" },
    toshow: { type: String, default: "" },
    hqID: { type: String, default: "" },
    hqName: { type: String, default: "" },
  },
  components: {
    defaultProfile,
    GoogleMap,
    PortfolioCreate,
    PortfolioFilterQuick,
    ExportVs,
    ExportProps,
    Analytics,
  },
  data() {
    return {
      showAddPortfolio: false,
      isLoading: true,

      // table, search & paging
      tab: null,
      vstabs: ["Portfolios", "Analytics"],
      vsheaders: [
        {
          text: "Portfolio Name",
          align: "start",
          sortable: true,
          value: "name",
          selected: true,
        },
        {
          text: "Managed By",
          align: "start",
          sortable: true,
          value: "manco",
          selected: true,
        },
        {
          text: "Owner",
          align: "start",
          sortable: true,
          value: "owner",
          selected: true,
        },
        {
          text: "Properties",
          align: "center",
          sortable: true,
          value: "propcount",
          selected: true,
        },
        {
          text: "VS Updates",
          align: "start",
          sortable: true,
          value: "update_period",
          selected: true,
        },
        {
          text: "Last Upated",
          align: "start",
          sortable: true,
          value: "updatedAt",
          selected: true,
        },
        {
          text: "Update Progress",
          align: "start",
          sortable: true,
          value: "checked_percent",
          selected: true,
        },
        {
          text: "Assigned To",
          align: "center",
          sortable: true,
          value: "vsTeamName",
          selected: true,
        },
        {
          text: "Actions",
          align: "end",
          sortable: false,
          value: "actions",
          selected: true,
        },
      ],
      search: "",
      portfolios: [],
      maxPortfolio: null,
      limitPortfolio: 1000,
      pagePortfolio: 1,

      // filters for GET_PORTFOLIOS (table data)
      contactsFilters: {},
      finalPropFilters: [{}],
      finalHqFilters: {},
      getPort: true,
      getHQs: false,
      hqIds: [],

      // derived counts within table result (kept if needed elsewhere)
      portfoliosIrregular: [],
      portfoliosIrregularCountTableScoped: 0,
      portfoliosActive: [],
      portfoliosActiveCountTableScoped: 0,

      // GLOBAL KPIs (independent of search)
      activePortfoliosGlobalCount: 0,
      irregularPortfoliosGlobalCount: 0,

      // misc
      items: null,
      expanded: [],

      refreshTable: null,
    };
  },

  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,

    /* THIS MONTH propchecks (numerator) */
    vspropchecks: {
      query: gql`
        query Vspropchecks($limit: Int!, $skip: Int!, $query: JSON!) {
          vspropchecks(limit: $limit, skip: $skip, query: $query) {
            records {
              id
              buildingid
              createdAt
            }
            count
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        const { start, end } = this.currentMonthRange;
        return {
          limit: 200000,
          skip: 0,
          query: { createdAt: { $gte: start, $lte: end } },
        };
      },
      update: (d) => d?.vspropchecks || { records: [], count: 0 },
    },

    /* PREVIOUS MONTH propchecks (rolling) */
    vspropchecksPrevMonth: {
      query: gql`
        query Vspropchecks($limit: Int!, $skip: Int!, $query: JSON!) {
          vspropchecks(limit: $limit, skip: $skip, query: $query) {
            records {
              id
              buildingid
              createdAt
            }
            count
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        const { start, end } = this.prevMonthRange;
        return {
          limit: 200000,
          skip: 0,
          query: { createdAt: { $gte: start, $lte: end } },
        };
      },
      update: (d) => d?.vspropchecks || { records: [], count: 0 },
    },

    /* ALL BUILDINGS (denominator) */
    vsbuildingsAll: {
      query: gql`
        query vsbuildings($limit: Int!, $skip: Int!, $query: JSON!) {
          vsbuildings(limit: $limit, skip: $skip, query: $query) {
            records {
              id
            }
            count
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        return { limit: 500000, skip: 0, query: {} };
      },
      update: (d) => d?.vsbuildings || { records: [], count: 0 },
    },

    /* GLOBAL Active portfolios independent of search */
    portfoliosActiveGlobal: {
      query: GET_PORTFOLIOS,
      fetchPolicy: "network-only",
      variables() {
        return { limit: 1, skip: 0, query: { irregular: false } };
      },
      result({ data }) {
        this.activePortfoliosGlobalCount = Number(data?.portfolios?.count || 0);
      },
    },

    /* GLOBAL Irregular portfolios independent of search */
    portfoliosIrregularGlobal: {
      query: GET_PORTFOLIOS,
      fetchPolicy: "network-only",
      variables() {
        return { limit: 1, skip: 0, query: { irregular: true } };
      },
      result({ data }) {
        this.irregularPortfoliosGlobalCount = Number(
          data?.portfolios?.count || 0
        );
      },
    },

    /* Table data (search-dependent) */
    portfolios: {
      query: GET_PORTFOLIOS,
      fetchPolicy: "network-only",
      variables() {
        const limit = this.limitPortfolio;
        const skip = limit * this.pagePortfolio - limit;
        return { limit, skip, query: { $or: this.finalPropFilters } };
      },
      skip() {
        return !this.getPort;
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading;
      },
      result(response) {
        const items = response.data.portfolios.records;
        this.maxPortfolio = response.data.portfolios?.count;

        // (table-scoped breakdowns retained if used elsewhere)
        this.portfoliosIrregular = items.filter((i) => i.irregular === true);
        this.portfoliosIrregularCountTableScoped =
          this.portfoliosIrregular.length;

        this.portfoliosActive = items.filter((i) => i.irregular === false);
        this.portfoliosActiveCountTableScoped = this.portfoliosActive.length;

        this.getPort = false;
      },
    },

    /* HQ name filter expansion */
    hqNames: {
      query: GET_HQNAMES_IDS,
      fetchPolicy: "network-only",
      variables() {
        return { limit: 0, skip: 0, query: this.finalHqFilters, sort: {} };
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading;
      },
      skip() {
        return !this.getHQs;
      },
      result({ data }) {
        this.getHQs = false;
        this.hqIds = data.hqNames.records.map((e) => e.id);
        this.finalPropFilters.push({ mancoid: { $in: this.hqIds } });
        this.getPort = true;
      },
    },
  },

  computed: {
    /* Dates & ranges */
    thismonthlong() {
      return moment().format("MMMM 'YY");
    },
    thismonth() {
      return moment().format("MMM 'YY");
    },
    prevMonthShort() {
      return moment().subtract(1, "months").format("MMM 'YY");
    },

    currentMonthRange() {
      const m = moment();
      return {
        start: m.startOf("month").valueOf(),
        end: m.endOf("month").valueOf(),
      };
    },
    prevMonthRange() {
      const m = moment().subtract(1, "months");
      return {
        start: m.startOf("month").valueOf(),
        end: m.endOf("month").valueOf(),
      };
    },

    /* Denominator: all buildings */
    totalBuildingsCount() {
      return Number(this.vsbuildingsAll?.count || 0);
    },

    /* THIS month: DISTINCT buildings checked */
    thisMonthDistinctBuildings() {
      const recs = (this.vspropchecks && this.vspropchecks.records) || [];
      const s = new Set();
      for (const r of recs) if (r?.buildingid != null) s.add(r.buildingid);
      return s.size;
    },
    buildingsCheckedPctThisMonth() {
      const total = this.totalBuildingsCount;
      const done = this.thisMonthDistinctBuildings;
      if (total <= 0) return 0;
      return Math.max(0, Math.min(100, Math.round((done / total) * 100)));
    },

    /* PREVIOUS month: DISTINCT buildings checked */
    prevMonthDistinctBuildings() {
      const recs =
        (this.vspropchecksPrevMonth && this.vspropchecksPrevMonth.records) ||
        [];
      const s = new Set();
      for (const r of recs) if (r?.buildingid != null) s.add(r.buildingid);
      return s.size;
    },
    buildingsCheckedPctPrevMonth() {
      const total = Number(this.totalBuildingsCount || 0);
      const done = Number(this.prevMonthDistinctBuildings || 0);
      if (total <= 0) return 0;
      return Math.max(0, Math.min(100, Math.round((done / total) * 100)));
    },

    /* Gauges */
    semiGaugeOptions() {
      return {
        chart: { toolbar: { show: false }, sparkline: { enabled: true } },
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            hollow: { size: "68%", margin: 0 },
            track: { background: "#ECEFF3", strokeWidth: "50%" },
            dataLabels: {
              show: true,
              name: { show: false },
              value: {
                fontSize: "22px",
                fontWeight: 600,
                offsetY: -14, // move % text up
                formatter: (val) => `${Math.round(val)}%`,
              },
            },
          },
        },
        stroke: { lineCap: "round" },
        colors: ["#FFA54D"], // this month color
        grid: { padding: { top: -6, bottom: -16 } }, // tighter vertical space
        tooltip: { enabled: false },
      };
    },
    semiGaugeOptionsPrev() {
      const base = this.semiGaugeOptions;
      return {
        ...base,
        colors: ["#30C293"], // previous month color
      };
    },
  },

  methods: {
    formatNum(n) {
      return new Intl.NumberFormat().format(n);
    },

    deleteItem(item) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085D6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete portfolio!",
      }).then(async (result) => {
        if (result.value) {
          try {
            const response = await this.$apollo.mutate({
              mutation: gql`
                mutation ($id: ID!) {
                  deletePortfolio(id: $id) {
                    id
                    deleted
                  }
                }
              `,
              variables: { id: item.id },
            });
            if (response) {
              this.$swal(
                "Success!",
                "Portfolio was successfully deleted",
                "success"
              );
              this.$apollo.queries.portfolios.refetch();
            }
          } catch (e) {}
        }
      });
    },
  },

  watch: {
    contactsFilters: {
      handler(newVal) {
        const filter = { ...newVal };
        this.finalPropFilters = [{}];
        this.finalHqFilters = {};
        this.hqIds = [];

        if (filter.name?.length > 0) {
          const or = [
            { name: { $regex: filter.name, $options: "i" } },
            { website: { $regex: filter.name, $options: "i" } },
          ];
          this.finalHqFilters = { $or: or };
          this.finalPropFilters = [
            { name: { $regex: filter.name, $options: "i" } },
          ];
          this.getHQs = true;
        } else {
          this.getPort = true;
        }
      },
      deep: true,
    },

    refreshTable() {
      this.getPort = true;
      this.$apollo.queries.portfolios.refetch();
    },
  },
};
</script>

<style lang="scss" scoped>
.text-h5 {
  font-weight: 600;
}
/* KPI layout */
.hq-kpi-row > .col {
  display: flex;
}
.kpi-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100px; /* consistent height; tweak as needed */
}
.kpi-body {
  margin-top: auto;
  padding-top: 4px !important;
  padding-bottom: 8px !important;
}
.kpi-chart {
  margin-top: auto; /* keep chart aligned similar across cards */
  padding: 0 !important;
}

/* Remove extra bottom whitespace in cards */
.new-note-card.v-card {
  padding: 6px !important;
}
.v-list-item {
  min-height: 34px !important;
  padding: 0 6px !important;
}
.text-h2 {
  line-height: 1.2em !important;
  font-weight: 600 !important;
}

/* Page header & general styles (kept from your file) */
.inline-icon {
  text-decoration: none;
}
.hq-details-row {
  background: #fff;
  padding: 14px 25px;
  box-shadow: 0 4px 6px 0 rgba(32, 33, 36, 0.1);
  border-radius: 6px;
  margin-bottom: 30px;
}
button.v-btn {
  box-shadow: none;
}
.goback,
.hq-main-title-card .breadcrumb-block a {
  text-decoration: none;
  font-size: 16px;
  display: inline-block;
}
.hq-main-title-card .heading {
  color: #100a55;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 7px;
}

/* Tabs */
.hq-tabs.v-tab {
  font-size: 14px;
  height: 37px;
  width: auto !important;
  color: #5e5873;
  font-weight: 600;
}
.v-window-item.v-window-item--active {
  padding-top: 20px;
}

/* Note card base */
.v-sheet.v-card.new-note-card {
  box-shadow: none !important;
  border: #e2f0ee solid 2px;
  border-radius: 8px;
}

/* (Other original styles kept minimal for brevity) */
</style>
